import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AfricaMap } from './ui/AfricaMap';
import { Button } from './ui/Button';
import { Counter } from './ui/Counter';
import { SearchIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const [tenderCount, setTenderCount] = useState(1000);
  useEffect(() => {
    // Simulate live counter by randomly increasing the number
    const interval = setInterval(() => {
      setTenderCount(prev => prev + Math.floor(Math.random() * 5));
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative pt-20 md:pt-0 bg-gradient-to-br from-blue-900 to-blue-800 text-white min-h-screen flex flex-col md:flex-row overflow-hidden" data-id="element-512">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-513">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-514">
          <defs data-id="element-515">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-516">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-517" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-518" />
        </svg>
      </div>
      {/* Left side - Map */}
      <div className="w-full md:w-1/2 h-64 md:h-auto relative" data-id="element-519">
        <AfricaMap data-id="element-520" />
        {/* Decorative elements */}
        <div className="absolute top-1/4 left-1/4 w-16 h-16 bg-yellow-500 rounded-full opacity-10 blur-xl" data-id="element-521"></div>
        <div className="absolute bottom-1/4 right-1/3 w-24 h-24 bg-blue-400 rounded-full opacity-10 blur-xl" data-id="element-522"></div>
      </div>
      {/* Right side - Content */}
      <div className="w-full md:w-1/2 p-6 md:p-12 lg:p-16 flex flex-col justify-center relative z-10" data-id="element-523">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-524">
          <div className="inline-block px-3 py-1 bg-blue-800 bg-opacity-50 text-yellow-500 text-sm font-semibold rounded-full mb-4 border border-blue-700" data-id="element-525">
            Plateforme leader en France
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-526">
            La 1ère plateforme française d'opportunités d'affaires en Afrique
          </h1>
          <div className="bg-blue-800 bg-opacity-50 p-4 md:p-6 rounded-lg mb-6 inline-block border border-blue-700 shadow-lg" data-id="element-527">
            <div className="text-sm text-blue-200 font-medium" data-id="element-528">Aujourd'hui</div>
            <div className="flex items-baseline" data-id="element-529">
              <Counter end={tenderCount} prefix="+" suffix=" nouveaux appels d'offres" className="text-2xl md:text-3xl font-bold text-yellow-500" data-id="element-530" />
            </div>
          </div>
          <p className="text-lg mb-8 text-blue-100 max-w-lg" data-id="element-531">
            Des appels d'offres vérifiés, actualisés en temps réel, partout en
            Afrique. Accédez aux meilleures opportunités avant vos concurrents.
          </p>
          {/* Search bar */}
          <div className="relative mb-8 shadow-lg" data-id="element-532">
            <input type="text" placeholder="Rechercher par secteur, pays, mot-clé..." className="w-full p-4 pl-12 pr-4 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-500 border-none" data-id="element-533" />
            <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} data-id="element-534" />
          </div>
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-535">
            <Link to="/essai-gratuit" data-id="element-536">
              <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20 font-semibold" data-id="element-537">
                Essai gratuit 7 jours
              </Button>
            </Link>
            <Link to="/recherche" data-id="element-538">
              <Button variant="outline" size="lg" className="bg-transparent border-white text-white hover:bg-blue-800 font-semibold" data-id="element-539">
                Voir les offres maintenant
              </Button>
            </Link>
          </div>
          {/* Trust indicators */}
          <div className="mt-8 flex items-center text-sm text-blue-200" data-id="element-540">
            <div className="flex -space-x-2 mr-3" data-id="element-541">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-300 border-2 border-blue-900 flex items-center justify-center text-xs text-blue-900 font-bold" data-id="element-542">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>
            <span data-id="element-543">
              Plus de <strong data-id="element-544">500+ entreprises</strong> nous font déjà confiance
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}